var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8853 18.8278H39.375V18.75H22.5V26.25H33.0966C31.5506 30.6159 27.3966 33.75 22.5 33.75C16.2872 33.75 11.25 28.7128 11.25 22.5C11.25 16.2872 16.2872 11.25 22.5 11.25C25.3678 11.25 27.9769 12.3319 29.9634 14.0991L35.2669 8.79562C31.9181 5.67469 27.4388 3.75 22.5 3.75C12.1453 3.75 3.75 12.1453 3.75 22.5C3.75 32.8547 12.1453 41.25 22.5 41.25C32.8547 41.25 41.25 32.8547 41.25 22.5C41.25 21.2428 41.1206 20.0156 40.8853 18.8278Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91187 13.7728L12.0722 18.2906C13.7391 14.1637 17.7759 11.25 22.5 11.25C25.3678 11.25 27.9769 12.3319 29.9634 14.0991L35.2669 8.79562C31.9181 5.67469 27.4387 3.75 22.5 3.75C15.2981 3.75 9.05249 7.81594 5.91187 13.7728Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 41.2499C27.3432 41.2499 31.7438 39.3965 35.071 36.3824L29.2679 31.4718C27.3221 32.9515 24.9445 33.7519 22.5 33.7499C17.6232 33.7499 13.4822 30.6402 11.9222 26.3005L5.80786 31.0115C8.91099 37.0837 15.2129 41.2499 22.5 41.2499Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8853 18.8278H39.375V18.75H22.5V26.25H33.0966C32.3571 28.3279 31.025 30.1436 29.265 31.4728L29.2678 31.4709L35.0709 36.3816C34.6603 36.7547 41.25 31.875 41.25 22.5C41.25 21.2428 41.1206 20.0156 40.8853 18.8278Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoogle);
export default __webpack_public_path__ + "static/media/ic_google.7961b4b9b370755011ce3c7b61273e69.svg";
export { ForwardRef as ReactComponent };